import Api from 'src/api/Base'

class GetSpaceTypeLayouts extends Api {
  requestUrl = `/api/SpaceTypeLayout`
}

export default GetSpaceTypeLayouts
